import React, { Component } from 'react';
import { Row, Col, Tag, Input, Button, InputNumber,Divider, BackTop, Icon, Pagination, Spin, message,Modal } from 'antd';
import { app, api, config } from "../../app";

const { CheckableTag } = Tag;

class MStandard extends Component {
    constructor(props) {
        super(props);
        const class_info = props.class_info;
        this.state = {
            check_tag: class_info.id,
            class_info: class_info,
            page: 1,
            goodList: [],
            total: 0,
            searchValue: '',
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.goodSource(1);
        
        if(config.mall_isDo2){
            app.post(api. getMallActivity).then(({ flag, data, msg }) => {
                if (flag === 1) {
                    if(data.is_activity==1){
                        this.insureModal = Modal.warning({
                            title: '通知',
                            content: (
                              <div>
                               {
                              (data.mall_info || []).map((item, index) => {
                                return (
                                  <div key={index} style={{ marginTop: '1rem',display:'flex',alignItems:'center',cursor:'pointer' }} onClick={() => this.torealize(item.mall_id)}>
                                    <img src={config.imgUrl + item.mall_img} alt=""
                                      style={{
                                        maxWidth: '200px',
                                        maxHeight: '200px',
                                        marginRight:'10px',
                                        width: 'auto',
                                        height: 'auto'
                                      }} />
                                      <p style={{fontWeight:'bold',color:'#5e92b4',cursor:'pointer'}}   >前往了解</p>
                                  </div>
                                );
                              })
                            }
                              <p style={{color:'red',marginTop:'20px'}}>{data.remark||''}</p>  
                              </div>
                              
                            ),
                            centered: true,
                            onOk: () => {
                                config.mall_isDo2 = false;
                              },
                          });
                    }
                } else {
                    app.alert(msg, 'warn');
                }
            })
        }

    }

    componentWillUnmount() {
        this._isMounted = false;
    }
 
    /**
     * 商品数据
     * @param page
     */
    goodSource = (page, search_value) => {
        this.setState({ data_loading: true, page, search_value }, () => {
            const _this = this, params = {
                class_id: this.state.check_tag,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                page,
                search_value,
            };
            app.post(api.MallListing, params).then(({ flag, data, msg, total }) => {
                if (_this._isMounted) {
                    if (flag === 1) {
                        _this.setState({ goodList: data, total: parseInt(total) });
                        if (data == '') {
                            message.info(msg);
                        }
                    } else {
                        app.alert(msg, 'warn');
                    }
                    if (_this.state.page === page) {
                        _this.setState({ page, data_loading: false });
                    }
                }
            })
        })
    }

    /**
     * 标签点击
     * @param i
     * @param checked
     */
    handleTagChange = (id, checked) => {
        if (!checked) id = this.state.class_info.id;
        this.setState({ check_tag: id, goodList: [], total: 0 }, () => {
            this.goodSource(1);
        });
    }

    // 去购物车
    goToCart = () => {
        let a = app.checkLogin();
        if (a) {
            app.alert("请登录后操作");
            setTimeout(() => {
                this.props.history.push('/login');                
            }, 500);
        } else {
            this.props.history.push('/cart_index/');
        }
    }

    toDetail = (id) => {
        this.props.history.push('/mall/detail/' + id);
    }

    torealize = (mall_id) =>{
        this.insureModal.destroy()
        this.props.history.push(`/mall/detail/${mall_id}`)
    }


    componentWillReceiveProps(props) {
        const { class_info } = this.state, class_info2 = props.class_info;
        if (class_info.id !== class_info2.id) {
            this.setState({ class_info: class_info2, check_tag: class_info2.id, goodList: [], total: 0 }, () => {
                this.goodSource(1);
            })
        }
    }

    // 获取搜索内容
    handleChange = (e) => {
        this.setState({
            searchValue: e.target.value
        })
    }

    handlePageChange = (page) => {
        this.goodSource(page);
    }

    render() {
        const { class_info, check_tag, page, goodList, total, data_loading } = this.state;
        return (
            <div className="mall-standard">
                <div className="filter">
                    {
                        (class_info.subclass || []).map((sub1, i1) => {
                            return (
                                <div key={i1} className="f-item">
                                    <p className="fi-title">{sub1.class_name}</p>
                                    <div className="fi-items">
                                        {
                                            (sub1.subclass || []).map((sub2, i2) => (
                                                <CheckableTag
                                                    key={i2}
                                                    checked={sub2.id === check_tag}
                                                    color="#2db7f5"
                                                    onChange={(checked) => this.handleTagChange(sub2.id, checked)}
                                                >
                                                    {sub2.class_name}
                                                </CheckableTag>

                                            ))
                                        }
                                    </div>
                                </div>
                            );
                        })
                    }
                    <Row className="f-item" style={{margin: '0 auto', maxWidth: '768px'}}>
                        <Col span={20} className="fi-search">
                            <Input id="g-search" style={{display: 'inline-block', width: 'calc(100% - 100px)', marginRight: '20px'}} onChange={(e) => this.handleChange(e)} />
                            <Button type="primary" onClick={() => this.goodSource(this.state.page, this.state.searchValue)}>搜索</Button>
                        </Col>
                        {/* <Col span={8} className="fi-price" offset={1}>
                            <label htmlFor="g-price-min">价格</label>
                            <div className="f-input">
                                <InputNumber id="g-price-min" min={0} precision={2}/>
                                <span> ─ </span>
                                <InputNumber min={1} precision={2}/>
                            </div>
                        </Col> */}
                        <Col span={4}>
                            <Button type="default" danger style={{width: '100%', color: 'red'}} onClick={() => this.goToCart()}>
                                我的购物车
                                {/* <div className="iconfont icon-circle"></div>
                                <div className="iconfont icon-liulan"></div>
                                <div className="iconfont icon-bianji"></div>
                                <div className="iconfont icon-beibaoxianren"></div>
                                <div className="iconfont icon-dangyuandangyuanguanlidangyuanzhuanchu"></div>
                                <div className="iconfont icon-renminbi"></div>
                                <div className="iconfont icon-shangyige"></div>
                                <div className="iconfont icon-suo"></div>
                                <div className="iconfont icon-masses"></div>
                                <div className="iconfont icon-guohui"></div>
                                <div className="iconfont icon-weibiaoti---"></div>
                                <div className="iconfont icon-drop_down"></div>
                                <div className="iconfont icon-Add_players"></div>
                                <div className="iconfont icon-head_default_img"></div>
                                <div className="iconfont icon-Civil_administration"></div>
                                <div className="iconfont icon-Brand_authorization_"></div>
                                <div className="iconfont icon-Sign_out"></div>
                                <div className="iconfont icon-search"></div>
                                <div className="iconfont icon-ranking"></div>
                                <div className="iconfont icon-team_icon"></div>
                                <div className="iconfont icon-Brand_authorization"></div>
                                <div className="iconfont icon-logo_"></div>
                                <div className="iconfont icon-user_icon"></div>
                                <div className="iconfont icon-See"></div>
                                <div className="iconfont icon-password"></div>
                                <div className="iconfont icon-Account_number"></div>
                                <div className="iconfont icon-yingjiduiwu"></div>
                                <div className="iconfont icon-baobei"></div>
                                <div className="iconfont icon-expert"></div>
                                <div className="iconfont icon-report_a_case"></div>
                                <div className="iconfont icon-library"></div>
                                <div className="iconfont icon-mission"></div>
                                <div className="iconfont icon-feedback"></div>
                                <div className="iconfont icon-notice"></div>
                                <div className="iconfont icon-punch_the_clock"></div>
                                <div className="iconfont icon-fenxiang1"></div>
                                <div className="iconfont icon-sheng"></div>
                                <div className="iconfont icon-laji"></div>
                                <div className="iconfont icon-quanguo"></div>
                                <div className="iconfont icon-dangwugongkai"></div>
                                <div className="iconfont icon-dashuju"></div>
                                <div className="iconfont icon-yuedu"></div>
                                <div className="iconfont icon-minzhengzhucexinxi1"></div>
                                <div className="iconfont icon-yihuodepinpaishouquan1"></div>
                                <div className="iconfont icon-gerenzhongxinwoderenwubiaozhuntoumianxing"></div>
                                <div className="iconfont icon-minzhudang"></div>
                                <div className="iconfont icon-yubeidangyuanyilan"></div>
                                <div className="iconfont icon-fenxiang"></div>
                                <div className="iconfont icon-yixiajia"></div>
                                <div className="iconfont icon-yilidui"></div>
                                <div className="iconfont icon-yikaichu"></div>
                                <div className="iconfont icon-yiqingtui"></div>
                                <div className="iconfont icon-yiyuedu"></div>
                                <div className="iconfont icon-gongqingtuanhui"></div>
                                <div className="iconfont icon-dang"></div>
                                <div className="iconfont icon-sanjiuxueshe"></div>
                                <div className="iconfont icon-weibiaoti-"></div>
                                <div className="iconfont icon-weibiaoti-1"></div> */}
                            </Button>
                        </Col>
                    </Row>
                </div>
                <div className="goods">
                    {
                        data_loading ? <Spin style={{ width: '100%' }} /> :
                            [
                                goodList.map((good, i) => (
                                    <div className="good" key={i}>
                                        <div className="good-img" onClick={() => this.toDetail(good.id)}><img
                                            src={good.type == 1 ? config.imgUrl + good.product_img : (good.merchant_id == 2 ? config.imgUrlType2 + good.product_img : config.imgUrlType3 + good.product_img)} alt="" width="100%"
                                            height="100%" /></div>
                                        <p className="good-name" onClick={() => this.toDetail(good.id)}>{good.ppename}</p>
                                        <div className="good-info">
                                            <strong className="gi-price">￥{good.ppeprice}</strong>
                                            {/*<span className="gi-count">已售： {good.count || 0}件</span>*/}
                                        </div>
                                    </div>
                                ))
                                , <Pagination key={goodList.length} current={page} total={total} pageSize={20}
                                    style={{ textAlign: 'center' }} hideOnSinglePage={true}
                                    onChange={this.handlePageChange} />]
                    }

                </div>
                <BackTop target={() => document.getElementsByClassName('mall-standard')[0]}>
                    <div className="go-top">
                        <Icon type="up-circle-o" />
                    </div>
                </BackTop>
            </div>
        );
    }
}

export default MStandard;



// WEBPACK FOOTER //
// ./src/routes/mall/MStandard.jsx